import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography
} from '@mui/material'
import { FC } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useArchiveIntakeRequestMutation } from '../../../redux/api/customerFormsApi'
import { IntakeRequestEntryExpanded } from '../../../sdk'
import { describeVehicle } from '../../../utils'

interface Props {
  showDismiss: boolean
  intakeRequest: IntakeRequestEntryExpanded
  includeCannedJobs: boolean
  setIncludeCannedJobs: (value: boolean) => void
  authorizeCannedJobs: boolean
  setAuthorizeCannedJobs: (value: boolean) => void
}

const RepairOrderCreationInfoPanel: FC<Props> = ({
  showDismiss,
  intakeRequest,
  includeCannedJobs,
  setIncludeCannedJobs,
  authorizeCannedJobs,
  setAuthorizeCannedJobs
}) => {
  const { accessToken } = useAccessTokenAndShopId()
  const vehicle = intakeRequest.vehicle!

  const [archiveIntakeRequest, { isLoading: archiving }] =
    useArchiveIntakeRequestMutation()

  const handleDismiss = () => {
    archiveIntakeRequest({
      authorization: accessToken,
      requestId: intakeRequest?.entry?.id!
    })
  }

  const numCannedJobs = intakeRequest?.cannedJobs?.length

  return (
    <>
      {intakeRequest.entry!.info!.repairOrderId! ? (
        <Alert color="info">
          The specified customer registration has already been addressed by
          another repair order.
        </Alert>
      ) : (
        <Card>
          <CardContent>
            <Typography variant="h6">
              The selected customer has an existing request for service.
            </Typography>
            <Typography variant="subtitle1">Vehicle</Typography>
            <Typography variant="body1">
              {describeVehicle(vehicle.info)}
            </Typography>
            <Typography variant="subtitle1">Concern</Typography>
            <Typography variant="body1">
              {intakeRequest.entry!.info!.concern || '(None)'}
            </Typography>
            {numCannedJobs && (
              <Box>
                <Typography variant="subtitle1">Canned Jobs</Typography>
                <Typography variant="body1">{numCannedJobs}</Typography>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={includeCannedJobs}
                        onChange={(event) =>
                          setIncludeCannedJobs(event.target.checked)
                        }
                      />
                    }
                    label="Auto-add requested canned jobs"
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={!includeCannedJobs}
                        checked={includeCannedJobs && authorizeCannedJobs}
                        onChange={(event) =>
                          setAuthorizeCannedJobs(event.target.checked)
                        }
                      />
                    }
                    label="Mark requested canned jobs as authorized"
                  />
                </FormGroup>
              </Box>
            )}
          </CardContent>
          <CardActions>
            {showDismiss && (
              <Button
                onClick={handleDismiss}
                disabled={archiving}
                variant="outlined">
                {archiving ? 'Sending...' : 'Dismiss'}
              </Button>
            )}
          </CardActions>
        </Card>
      )}
    </>
  )
}

export default RepairOrderCreationInfoPanel
